export default {
  'panic-button': {
    today: 'Today',
    'current-week': 'Current week',
    'current-month': 'Current month',
    'show-calendar': 'Show calendar',
  },
  'show-more': 'Show all +{howMany} more',
  'show-all': 'Show all ({howMany})',

  'all-working-staff': 'All Working Staff',
  'all-resources': 'All Resources',

  'number-day-month-appointments': '{count} appointment | {count} appointments | {count} appointments',

  filters: {
    'label': 'Filters',
    'staffers': 'Staff',
    'resources': 'Resources',
    'default': 'Default',
    'working-staff': 'Working Staff Members',
    'only-me': 'Only me',
    'working': 'Working',
    'show-only': 'Highlight',
    'staff-and-resources': 'Staff and Resources',
    'payments': 'Payments',
    'appoinment-status': 'Appointment Status',
    'staff-member-selected': 'Staff member selected',
    'details': 'Details',
    'paid': 'Paid',
    'unpaid': 'Unpaid',
    'confirmed': 'Confirmed',
    'need-confirm': 'Need confirm',
    'no-show': 'No-show',
    'by-client': 'By client',
    'automatically': 'Automatically',
    'starred': 'Starred',
    'unstarred': 'Unstarred',
    'start-turn': 'Start turn',
  },

  notifications: {
    filters: {
      'label': 'Filters',
      'default': 'Default',
      appointment: 'New & Changed Appointments',
      cancellation: 'Cancellations',
      comments: 'Comments',
      confirm: 'Pending Confirmation',
      iterable: 'News from Booksy',
      mobile_payment: 'Mobile Payments',
      no_show: 'No-Shows & Late Cancellations',
      reviews: 'Reviews',
    },
    'active': 'Active',
    'archive': 'Archive',
    'archive-all': 'Archive all',
    'archived': 'Archived',
    'no-notifications': 'No notifications yet...',
  },

  view: {
    day: 'Day',
    week: 'Week',
    month: 'Month',
  },

  bookings: {
    'time-off': 'Time off',
    'time-off-reason': {
      'personal_day': 'Personal Day',
      'sick_day': 'Sick day',
      'vacation': 'Vacation',
      'training': 'Training',
      'no_show': 'No-show',
      'late': 'Late for work',
      'early': 'Early leave',
      'other': 'Other absence reason',
    },
    'break': 'Break',
  },

  'headline': {
    'resource': {
      'show-day-view': 'Show day view',
      'add-time-off': 'Add time off',
      'edit-working-hours': 'Edit working hours',
      'edit-shift': 'Edit shift',
    },
  },

  'settings': {
    'title': 'Calendar settings',
    'default-view': {
      'title': 'Default view',
      'description': 'Select your preferred calendar view to see a detailed daily schedule or have an overview of your workload over a longer period.',
      'hint': 'Your calendar will be displayed in the selected default view every time you open Booksy. Choose the Day view to see detailed timetables of all staff members by day or go for the Week and Month views if you plan your work further ahead. In the Agenda view, all upcoming appointments are displayed in a list. You can switch to a different view anytime by selecting the most convenient option above your calendar. The default view will be restored next time you open it.',
      'hint-title': 'How does Default view work?',
      'hint-heading': 'Default view',
      'options': {
        daily: 'Day',
        weekly: 'Week',
        monthly: 'Month',
        agenda: 'Appointment List',
      },
    },
    'width-mode': {
      title: 'Display mode',
      'description': 'Do you want to see all staff member calendars at a glance? Or do you prefer a full-sized calendar with more details? Choose your preferred display mode.',
      'hint': 'In the Full size mode, your calendar will have a set resolution regardless of your screen size. A horizontal scroll will help you navigate. If you choose the Fit to page mode, the calendar will adjust to the size of your screen and you’ll be able to see all staff members at a glance. In this mode, some details will not be visible on the appointment tiles but you will be able to easily spot any empty slots.',
      'hint-title': 'How does Display mode work?',
      'hint-heading': 'Display mode',
      options: {
        'fixed': 'Full size',
        'fit': 'Fit to page',
      },
    },
    'color-scheme': {
      'title': 'Color scheme',
      'desciption': 'Customize the color scheme on your calendar. Choose a vivid palette of contrasting colors to make appointments easier to distinguish or a pastel scheme for lighter shades.',
      'options': {
        'pastel': 'Pastel',
        'vivid': 'Vivid',
      },
    },
    'go-to-shifts': {
      'title': 'Business Hours, Shifts and Time Offs',
      'action': 'Go to Shifts',
    },
  },

  'import': {
    'errors': {
      'size': 'File too large. Please try again with a smaller file.',
      'size-notification': 'The file is too large',
      'format': 'The file is in the wrong format. Please try again using the correct file format.',
      'format-notification': 'The file is in the wrong format',
      'corrupted': 'Import failed. Please try again.',
      'corrupted-notification': 'Failed to load the file',
      'import': 'Failed to import file "{fileName}". Please try again.',
      'discard-failed': 'Failed to delete imported events. Please try again.',
    },
    'success': {
      'discard-completed': 'Your last imported events have been deleted. You can now import another file.',
    },
    'waiting-for-file': {
      'title': 'Calendar Import',
      'description': 'Use Calendar Import to easily add events from your current calendar into Booksy all at once.',
      'allowed-format': 'Accepted file type is {allowedFileFormats}.',
      'allowed-formats': 'Accepted file types are {allowedFileFormats}.',
      'allowed-max-size': 'File must be {allowedFileSize} or less.',
      'action-btn': 'Choose a calendar file',
    },
    'begin-import': {
      'title': 'Calendar Import',
      'description': 'Confirm we have the correct file below, and we can begin the import. The process may take up to 10 minutes.',
      'action-btn': 'Import calendar events',
      'cancel-btn': 'Not now',
    },
    'importing': {
      'title': 'Processing...',
      'description': 'We are importing your calendar, this may take up to 10 minutes. Feel free to move around the app whilst we import, it won\'t disturb the process.',
    },
    'imported': {
      'title': 'Imported Calendar',
      'description': 'Your Booksy calendar has been updated with events from the imported file.<br /><br />Need to make a change?<br />You can always remove imported events and replace them with events from a new file.',
      'imported': 'Imported: {importDate}',
      'action-btn': 'Remove imported events',
    },
    'discarding': {
      'title': 'Removing imported events from your calendar...',
    },
    'discarding-modal': {
      'title': 'Remove imported events?',
      'text': 'This action cannot be undone. Events created or edited directly in Booksy will not be deleted.',
      'confirm-btn': 'Remove imported events',
      'cancel-btn': 'Go back',
    },
    'show-more': {
      'button': 'Need some help?',
      'modal': {
        'title': 'Need some help?',
        'text': 'To get a file with your calendar data you must export it from your current app. How to do this will vary depending on which app you currently use but a quick Google search should guide you in the right direction. Once you have the file be sure to check the points below.',
        'term-1': 'The file must be a {allowedFileFormats} format.',
        'term-2': 'The file must be {allowedFileSize} or less in size.',
        'term-3': 'The maximum time range that can be imported is 1 month in the past and 2 years in the future.',
        'term-4': 'It is not possible to import events that cover a few days.',
        'term-5': 'It is not possible to import events shorter than 5 minutes.',
        'tutorial-link-text': 'How to export a calendar file?',
      },
    },
  },
  'virtual-appointment': {
    'title': 'Start your booking journey',
    'description': 'Test your system by creating this first appointment. You\'ll get a test notification as well.',
    'call-to-action': 'Click to start',
  },
}
